var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankLine = function SvgBankLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 19.2h18V21h-18zM5.3 12h1.8v6.3H5.3zm4.5 0h1.8v6.3H9.8zm3.6 0h1.8v6.3h-1.8zm4.5 0h1.8v6.3h-1.8zM3.5 7.5l9-4.5 9 4.5v3.6h-18zm1.8 1.112V9.3h14.4v-.688l-7.2-3.6zm7.2-.212a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8"
  })));
};
export default SvgBankLine;